// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IhWMr2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
  border-bottom: 1px solid var(--stroke-neutral-subtle);
}

.ixJZgs {
  gap: 0;
  justify-content: flex-start;
  height: 67px;
  min-height: 67px;
  padding: 0;
}

.ykR4Q7 {
  justify-content: flex-start;
  min-height: 67px;
  padding: var(--spacing-1-5) 0;
}

.ykR4Q7 .QHriuk {
  flex: 0 0 115px;
}

.QHriuk {
  display: flex;
  align-items: center;
  gap: var(--spacing-0-5);
  flex: 0 0 109px;
  min-height: 24px;
}

.YHTb89 {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: 20px;
  color: var(--text-neutral-dark);
  white-space: nowrap;
}

.jAOgCm {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 12px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: var(--radius-s);
}

.jAOgCm:focus-visible {
  outline: 2px solid var(--stroke-primary-medium);
  outline-offset: 1px;
}

.PjN2a0 {
  width: 12px !important;
  height: 12px !important;
}

.nc_FLS {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
  min-width: 0;
}

.AFW7Tl {
  flex: 1 1 auto;
}

.t3PaxK {
  flex: 1 1 auto;
  max-width: none;
}

.wXEe1Q {
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-0-5);
  min-width: 0;
  min-height: 28px;
  height: auto;
  overflow: visible;
}

.JvhCrw {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 16px;
}

.ITZl1h {
  flex: 1 1 0;
  min-width: 4px;
  height: 1px;
  background-color: var(--icon-neutral-silver);
}

.wXEe1Q:first-child .VB3Cc0 {
  opacity: 0;
}

.wXEe1Q:last-child .ilBV9G {
  opacity: 0;
}

.uewirv .ITZl1h {
  background-color: var(--status-success);
}

.xSha94 .VB3Cc0 {
  background-color: var(--status-success);
}

.xSha94 .ilBV9G {
  background-color: var(--stroke-primary-medium);
}

.uiFnkv .VB3Cc0 {
  background-color: var(--status-error);
}

.uiFnkv .ilBV9G {
  background-color: var(--icon-neutral-silver);
}

.g5z4Zq {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  border-radius: var(--radius-pill);
  border: 1px solid var(--stroke-neutral-silver);
  background-color: var(--surface-neutral-silver);
  color: var(--text-neutral-white);
}

.uewirv .g5z4Zq {
  border-color: var(--status-success);
  background-color: var(--status-success);
}

.xSha94 .g5z4Zq {
  border-color: var(--stroke-primary-medium);
  background-color: var(--surface-primary-medium);
}

.ncK0PN .g5z4Zq {
  border-color: var(--stroke-neutral-silver);
  background-color: var(--surface-neutral-silver);
}

.uiFnkv .g5z4Zq {
  border-color: var(--status-error);
  background-color: var(--status-error);
}

.B3q4pz {
  width: 8px !important;
  height: 8px !important;
}

.HiPOo2 {
  width: 12px !important;
  height: 12px !important;
  cursor: default !important;
}

.mw8FfL {
  font-family: var(--font-family-base);
  font-size: 10px;
  font-weight: var(--font-weight-regular);
  line-height: 14px;
  color: var(--text-neutral-white);
}

.hpKYRc {
  flex-shrink: 0;
  max-width: 100%;
  overflow: visible;
  white-space: nowrap;
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  line-height: 17px;
  text-align: center;
  color: var(--text-neutral-dark);
}

.ncK0PN .hpKYRc {
  color: var(--text-neutral-silver);
}

.ixJZgs .EIQGKL {
  justify-content: flex-end;
}

.EIQGKL {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-1);
  flex: 0 0 95px;
  width: 95px;
  min-height: 24px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  line-height: 20px;
  color: var(--text-primary-medium);
  white-space: nowrap;
}

.EIQGKL:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.EIQGKL:focus-visible {
  outline: 2px solid var(--stroke-primary-medium);
  outline-offset: 2px;
  border-radius: var(--radius-s);
}

.ewSLlr {
  width: 14px !important;
  height: 14px !important;
}

@media (max-width: 768px) {
  .IhWMr2 {
    flex-wrap: wrap;
    gap: var(--spacing-1-5);
  }

  .nc_FLS {
    order: 3;
    max-width: none;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/CardShipmentCard/CardShipmentCard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,WAAW;EACX,qDAAqD;AACvD;;AAEA;EACE,MAAM;EACN,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,8CAA8C;EAC9C,+CAA+C;EAC/C,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;EACE,0CAA0C;EAC1C,+CAA+C;AACjD;;AAEA;EACE,0CAA0C;EAC1C,+CAA+C;AACjD;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,uCAAuC;EACvC,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,oCAAoC;EACpC,8BAA8B;EAC9B,sCAAsC;EACtC,iBAAiB;EACjB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,QAAQ;IACR,eAAe;IACf,WAAW;EACb;AACF","sourcesContent":[".card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n  width: 100%;\n  border-bottom: 1px solid var(--stroke-neutral-subtle);\n}\n\n.cardHome {\n  gap: 0;\n  justify-content: flex-start;\n  height: 67px;\n  min-height: 67px;\n  padding: 0;\n}\n\n.cardList {\n  justify-content: flex-start;\n  min-height: 67px;\n  padding: var(--spacing-1-5) 0;\n}\n\n.cardList .codeGroup {\n  flex: 0 0 115px;\n}\n\n.codeGroup {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-0-5);\n  flex: 0 0 109px;\n  min-height: 24px;\n}\n\n.trackingCode {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  line-height: 20px;\n  color: var(--text-neutral-dark);\n  white-space: nowrap;\n}\n\n.copyButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 12px;\n  height: 12px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  border-radius: var(--radius-s);\n}\n\n.copyButton:focus-visible {\n  outline: 2px solid var(--stroke-primary-medium);\n  outline-offset: 1px;\n}\n\n.copyIcon {\n  width: 12px !important;\n  height: 12px !important;\n}\n\n.stepper {\n  display: flex;\n  flex: 1 1 auto;\n  align-items: center;\n  justify-content: center;\n  min-width: 0;\n}\n\n.stepperHome {\n  flex: 1 1 auto;\n}\n\n.stepperList {\n  flex: 1 1 auto;\n  max-width: none;\n}\n\n.step {\n  display: flex;\n  flex: 1 1 0;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-0-5);\n  min-width: 0;\n  min-height: 28px;\n  height: auto;\n  overflow: visible;\n}\n\n.stepRow {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 16px;\n}\n\n.connector {\n  flex: 1 1 0;\n  min-width: 4px;\n  height: 1px;\n  background-color: var(--icon-neutral-silver);\n}\n\n.step:first-child .connectorLeft {\n  opacity: 0;\n}\n\n.step:last-child .connectorRight {\n  opacity: 0;\n}\n\n.stepCompleted .connector {\n  background-color: var(--status-success);\n}\n\n.stepCurrent .connectorLeft {\n  background-color: var(--status-success);\n}\n\n.stepCurrent .connectorRight {\n  background-color: var(--stroke-primary-medium);\n}\n\n.stepError .connectorLeft {\n  background-color: var(--status-error);\n}\n\n.stepError .connectorRight {\n  background-color: var(--icon-neutral-silver);\n}\n\n.indicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 16px;\n  height: 16px;\n  border-radius: var(--radius-pill);\n  border: 1px solid var(--stroke-neutral-silver);\n  background-color: var(--surface-neutral-silver);\n  color: var(--text-neutral-white);\n}\n\n.stepCompleted .indicator {\n  border-color: var(--status-success);\n  background-color: var(--status-success);\n}\n\n.stepCurrent .indicator {\n  border-color: var(--stroke-primary-medium);\n  background-color: var(--surface-primary-medium);\n}\n\n.stepPending .indicator {\n  border-color: var(--stroke-neutral-silver);\n  background-color: var(--surface-neutral-silver);\n}\n\n.stepError .indicator {\n  border-color: var(--status-error);\n  background-color: var(--status-error);\n}\n\n.checkIcon {\n  width: 8px !important;\n  height: 8px !important;\n}\n\n.errorIcon {\n  width: 12px !important;\n  height: 12px !important;\n  cursor: default !important;\n}\n\n.stepNumber {\n  font-family: var(--font-family-base);\n  font-size: 10px;\n  font-weight: var(--font-weight-regular);\n  line-height: 14px;\n  color: var(--text-neutral-white);\n}\n\n.stepLabel {\n  flex-shrink: 0;\n  max-width: 100%;\n  overflow: visible;\n  white-space: nowrap;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  line-height: 17px;\n  text-align: center;\n  color: var(--text-neutral-dark);\n}\n\n.stepPending .stepLabel {\n  color: var(--text-neutral-silver);\n}\n\n.cardHome .detailsButton {\n  justify-content: flex-end;\n}\n\n.detailsButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-1);\n  flex: 0 0 95px;\n  width: 95px;\n  min-height: 24px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-medium);\n  line-height: 20px;\n  color: var(--text-primary-medium);\n  white-space: nowrap;\n}\n\n.detailsButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.detailsButton:focus-visible {\n  outline: 2px solid var(--stroke-primary-medium);\n  outline-offset: 2px;\n  border-radius: var(--radius-s);\n}\n\n.detailsIcon {\n  width: 14px !important;\n  height: 14px !important;\n}\n\n@media (max-width: 768px) {\n  .card {\n    flex-wrap: wrap;\n    gap: var(--spacing-1-5);\n  }\n\n  .stepper {\n    order: 3;\n    max-width: none;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `IhWMr2`,
	"cardHome": `ixJZgs`,
	"cardList": `ykR4Q7`,
	"codeGroup": `QHriuk`,
	"trackingCode": `YHTb89`,
	"copyButton": `jAOgCm`,
	"copyIcon": `PjN2a0`,
	"stepper": `nc_FLS`,
	"stepperHome": `AFW7Tl`,
	"stepperList": `t3PaxK`,
	"step": `wXEe1Q`,
	"stepRow": `JvhCrw`,
	"connector": `ITZl1h`,
	"connectorLeft": `VB3Cc0`,
	"connectorRight": `ilBV9G`,
	"stepCompleted": `uewirv`,
	"stepCurrent": `xSha94`,
	"stepError": `uiFnkv`,
	"indicator": `g5z4Zq`,
	"stepPending": `ncK0PN`,
	"checkIcon": `B3q4pz`,
	"errorIcon": `HiPOo2`,
	"stepNumber": `mw8FfL`,
	"stepLabel": `hpKYRc`,
	"detailsButton": `EIQGKL`,
	"detailsIcon": `ewSLlr`
};
module.exports = ___CSS_LOADER_EXPORT___;
